import React from "react";
import { NewNotificationsForm } from "../../components";

const NewLiteracy = () => {
  return <NewNotificationsForm></NewNotificationsForm>;
};

export default NewLiteracy;
